var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form border"},[_c('h1',[_vm._v(_vm._s(_vm.$lang('TITLE_SEND_EMAIL_SUCCESS')))]),_c('router-link',{staticStyle:{"float":"right"},attrs:{"to":{name: 'home'}}},[_vm._v(_vm._s(_vm.$lang('TITLE_RETURN_INDEX')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }